module.exports = __webpack_public_path__ + "img/twitter.d2863f38.svg";